/**
*信令缓存，用来处理去重
**/
class SignalCache {
    constructor() {
        this.index = 0 ;
        this.MAX_MESSAGE_COUNT  = 1000;
        this.cacheArr = [];
    }

    cache(value){
        var idx = this.cacheArr.indexOf(value);
        if (this.index >= this.MAX_MESSAGE_COUNT){
            this.index = 0;
        }
        this.cacheArr[this.index] = value;
        this.index++;
        return idx != -1;
    }
}
export default SignalCache;

